import { render, staticRenderFns } from "./MealDay.vue?vue&type=template&id=1b65151d&scoped=true&"
import script from "./MealDay.vue?vue&type=script&lang=js&"
export * from "./MealDay.vue?vue&type=script&lang=js&"
import style0 from "./MealDay.vue?vue&type=style&index=0&id=1b65151d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65151d",
  null
  
)

export default component.exports